import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import TabsPanel from 'components/tabs/TabsPanel';
import SimpleLoader from 'components/loader/SimpleLoader';
import { BackButton } from 'components/buttons';
import Header, { ButtonConfig } from 'components/header/Header';
import { Editor, TableColumns, TablePreview } from './components';
import { useModal } from 'hooks/useModal';
import useTables from './hooks/useTables';

// WE WILL ALLOW USERS TO SEE PREVIEW OR OVERVIEW BASED ON THE BLOCKPREVIEW FIELD ON THE ENV
const TableView = () => {
    const params = useParams();
    const [counter, setCounter] = useState(1);
    const { openTableAccess } = useModal();

    const { tableLabel, datasetLabel, loading, error, blockPreview } =
        useTables();
    const tooltipContent =
        blockPreview &&
        `To access this functionality you need to check if 'Block Preview to datasets' is set to 'None ('Allow all previews') on Environment
    that this dataset belongs or if you belong to the 'Admin groups' of the Environment.`;

    const buttonConfig: ButtonConfig[] = [
        {
            label: 'Request access to table',
            onClick: () =>
                openTableAccess({
                    resourceUri: params.uri ?? '',
                    label: tableLabel,
                    datasetLabel,
                }),
            icon: 'key',
        },
    ];

    return (
        <div>
            {loading ? (
                <SimpleLoader />
            ) : (
                !error && (
                    <div>
                        <BackButton counter={counter} />
                        <Header
                            title={tableLabel}
                            buttonConfigs={buttonConfig}
                        />
                        <TabsPanel
                            counter={counter}
                            setCounter={setCounter}
                            tabs={[
                                {
                                    label: 'columns ',
                                    component: <TableColumns />,
                                },
                                {
                                    label: 'preview',
                                    component: <TablePreview />,
                                    disabled: blockPreview,
                                    tooltip: tooltipContent,
                                },
                                {
                                    label: 'overview',
                                    disabled: blockPreview,
                                    tooltip: tooltipContent,
                                    component: <Editor />,
                                },
                            ]}
                        />
                    </div>
                )
            )}
        </div>
    );
};

export default TableView;
